import { CloseIcon } from "../../utils/icon.utils";
import Button from "../../ui/Button";

export default function RemoveVehicleInventoryAccessoriesAckField({
  control,
  errors,
  setValue,
  others,
  unregister
}) {
  const { index, setFields } = others;

  function handleRemove() {
    setFields((prev) => {
      const prevField = [...prev];

      const filtered = prevField.filter((item) => item.index !== index);

      return filtered;
    });
    unregister(`accessories.${index}.label`);
    unregister(`accessories.${index}.remarks`);
    unregister(`accessories.${index}.is_okay`);
    unregister(`accessories.${index}.value`);
  }

  return (
    <>
      <div style={{ height: 35 }}></div>
      <Button color="danger" onClick={handleRemove} name="Remove" icon={CloseIcon} />
    </>
  );
}
